import React from "react";
import { connect } from "react-redux";
import Drawer from 'devextreme-react/drawer';
import Toolbar, { Item } from "devextreme-react/toolbar";
import List from "devextreme-react/list";
import { LoadIndicator } from "devextreme-react/load-indicator";
import { Button } from "devextreme-react/button";
import Form from "devextreme-react/form";
import ArrayStore from "devextreme/data/array_store";
import { ABECASUSER_LOGIN_TYPE } from "../../../common/permissions";
import TextArea from 'devextreme-react/text-area';
import Popup from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import TransactionsGridPreview from "../genaric-component/TransactionsGridPreview";
import TransactionsPrintErrors from "../genaric-component/TransactionsPrintErrors";
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import { LoadPanel } from 'devextreme-react/load-panel';
import { createStore } from "devextreme-aspnet-data-nojquery";
import { alert, confirm } from 'devextreme/ui/dialog';

import DataGrid, {
  Column,
  Editing,
  Lookup,
} from "devextreme-react/data-grid";
import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import DateBox from 'devextreme-react/date-box';
import Accordion from 'devextreme-react/accordion';
import { CheckBox } from "devextreme-react";
import './updateOrderStage.css'
import WarningMessagePopup from "./WarningMessagePopup";
import UpdatePriceGridPreview from "../genaric-component/UpdatePriceGridPreview";
const selectBox = React.createRef();
const selectBoxMacro = React.createRef();

const searchpanel = [
  {
    ID: 1,
    Name: 'Search Filters'
  }
];
const list = React.createRef();
const dataGrid = React.createRef();
const orderByData = [
  { ID: 0, Text: "None" },
  { ID: 1, Text: "Ascending" },
  { ID: 2, Text: "Descending" },
];
const priceLevels = [
  { ID: 'A', Text: 'Update to Price Level A' },
  { ID: 'B', Text: 'Update to Price Level B' },
  { ID: 'C', Text: 'Update to Price Level C' },
  { ID: 'D', Text: 'Update to Price Level D' },
  { ID: 'E', Text: 'Update to Price Level E' },
  { ID: 'F', Text: 'Update to Price Level F' },
  { ID: 'G', Text: 'Update to Price Level G' },
  { ID: 'I', Text: 'Update to Price Level I' },
  { ID: 'J', Text: 'Update to Price Level J' },
  { ID: 'K', Text: 'Update to Price Level K' },
  { ID: 'L', Text: 'Update to Price Level L' },
  { ID: 'M', Text: 'Update to Price Level M' },
  { ID: 'N', Text: 'No, Do Not Update Price Level' },
];
const applyAdjustmentFactors = [
  { ID: 'Y', Text: "Yes, Apply Adjustment Factor" },
  { ID: 'N', Text: "No, Do Not Apply Adjustment Factor" },
];
const shipMethod = [
  { ID: 'AUTO', Text: "Ship as Ordered - Automatic" },
  { ID: 'MAN', Text: "Ship as Specified by User - Manual" },
];
const orderByDataSource = new ArrayStore({
  data: orderByData,
  key: "ID",
});

const prefixData = [
  { ID: 0, Text: "And" },
  { ID: 1, Text: "Or" },
];

const prefixDataSource = new ArrayStore({
  data: prefixData,
  key: "ID",
});
const groupData = [
  { ID: 0, Text: "No" },
  { ID: 1, Text: "Begin" },
  { ID: 2, Text: "End" },
];
const operationData = [
  { ID: 0, Text: "StartsWith" },
  { ID: 1, Text: "EndsWith" },
  { ID: 2, Text: "Contains" },
  { ID: 3, Text: "Equal" },
  { ID: 4, Text: "NotEqual" },
  { ID: 5, Text: "Greater" },
  { ID: 6, Text: "GreaterEqual" },
  { ID: 7, Text: "Less" },
  { ID: 8, Text: "LessEqual" },
  { ID: 9, Text: "Between" },
  { ID: 10, Text: "Includes" },
];

const groupDataSource = new ArrayStore({
  data: groupData,
  key: "ID",
});
const operationDataSource = new ArrayStore({
  data: operationData,
  key: "ID",
});

let accessToken = "";
let ignoreListSelectionChange = false;
let ignoreMacroSelectionChange = false;
class UpdatePrice extends React.Component {
  constructor(props) {
    super(props);
    accessToken = props.oidc.user.access_token;
    this.handleClosePreviewPopUpCallback = this.handleClosePreviewPopUpCallback.bind(this);
    this.handleClosePrintErrorsPopUpCallback = this.handleClosePrintErrorsPopUpCallback.bind(this);
    this.ComitButtonClicked = this.startButtonClicked.bind(this);
    this.previewButtonClicked = this.previewButtonClicked.bind(this);
    this.resetButtonClicked = this.resetButtonClicked.bind(this);
    this.printErrorsButtonClicked = this.printErrorsButtonClicked.bind(this);
    this.selectionChanged = this.selectionChanged.bind(this);
    this.editorPreparing = this.editorPreparing.bind(this);
    this.CellClik = this.CellClik.bind(this);

    this.initialState = {
      animationDuration: 300,
      selectedItems: [],
      loadComitIndicatorVisible: false,
      isPreviewGridPopupVisible: false,
      isPrintPreviewPopupVisible: false,
      connection: null,
      opened: (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE),
      generatedFileName: "",
      report: {
        key: "",
        name: "",
        fullName: "",
        ignoreCompany: false,
        parameterList: [],
        queryParameters: [],
        whereInfoList: [],
        filterWhereInfoList: [
        ],
      },
      updatePriceParams: {
        priceLevel: 'N',
        applyAdjustmentFactor: 'N',
      },
      previewData: null,
      ABErros: null,
      formData: {},
      formItems: [],
      warningPopupVisible: false,
      SuccessPopupVisible: false,
      warningMessage: '',
      SuccessMessage: '',
      loadIndicatorVisible: false
    };
    this.state = { ...this.initialState };
    this.toolbarItems = [{
      widget: 'dxButton',
      location: 'right',
      options: {
        icon: 'menu',
        onClick: () => this.setState({ opened: !this.state.opened }),
      },
    }];
    this.loadReport();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.Name !== this.props.Name) {
      this.loadReport();
    }
  }
  startButtonClicked = async (e) => {
    e.event.stopPropagation();
    if (this.state.report.filterWhereInfoList.length<1) {
      const result = await confirm(
          `Record Range Selection Is Empty. Do You Wish To Continue?`,
          'Confirm'
      );
      if (!result) {
        return;
      }
  }
    this.setState({
      loadIndicatorVisible: true,
    });

    try {
      const response = await this.updatePrice();
      console.log(response)
      this.setState({ loadIndicatorVisible: false });
      if (response.errors > 0) {
        this.setState({
          warningMessage: "The State Change Process generated  " + response.errors + "  error message(s). Click Print Errors to view those.",
          warningPopupVisible: true
        })
      }
      if(response.transactions ===1){
        this.setState({
          SuccessMessage: response.transactions+" OM Transactions Updated Successfully.",
          SuccessPopupVisible: true
        });
      }
      else{
        this.setState({
          SuccessMessage: response.transactions+ " OM Transactions to Update.\n" + response.noChange+" OM Transactions With No Change Required.\n" + response.successful + " OM Transactions Updated Successfully.",
          SuccessPopupVisible: true
        });
      }
    } catch (error) {
      this.setState({ loadIndicatorVisible: false });
      console.error('Error:', error);
    }
  };
  updatePrice = async () => {
    try {

      await this.setState((prevState) => ({
        updatePriceParams: {
          ...prevState.updatePriceParams,
          ['filterWhereInfoList']: this.state.report.filterWhereInfoList
        }
      }));
      // Make the POST request to the API endpoint
      const res = await axios.post(
        `${window._env_.REACT_APP_APIS}/${routes.OM.CallUpdatePrice}`,
        JSON.stringify(this.state.updatePriceParams),
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return res.data; // Return the response data
    } catch (error) {
      this.setState({
        loadIndicatorVisible: false
      });
      console.error('Error updating order stage:', error);
      throw error; // Re-throw the error for handling in the component
    }
  };
  PreviewData = async () => {
    try {
      await this.setState((prevState) => ({
        updatePriceParams: {
          ...prevState.updatePriceParams,
          ['filterWhereInfoList']: this.state.report.filterWhereInfoList
        }
      }));
      const res = await axios.post(
        `${window._env_.REACT_APP_APIS}/${routes.OM.GetUpdatedPrices}`,
        JSON.stringify(this.state.updatePriceParams),
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      console.log(res.data);
      return res.data; // Return the response data
    } catch (error) {
      this.setState({
        loadIndicatorVisible: false
      });
      console.error('Error updating order stage:', error);
      throw error; // Re-throw the error for handling in the component
    }
  };
  GetABErrorswData = async () => {
    try {
      const res = await axios.post(
        `${window._env_.REACT_APP_APIS}/${routes.OM.GetABErrorsHeaders}`,
        JSON.stringify(this.state.updatePriceParams.program),
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return res.data; // Return the response data
    } catch (error) {
      this.setState({
        loadIndicatorVisible: false
      });
      console.error('Error updating order stage:', error);
      throw error; // Re-throw the error for handling in the component
    }
  };
  async previewButtonClicked(e) {
    e.event.stopPropagation();
    this.setState({
      loadIndicatorVisible: true
    });
    const data = await this.PreviewData();
    this.setState({
      previewData: data,
      isPreviewGridPopupVisible: true,
      loadIndicatorVisible: false
    });
  }
  resetButtonClicked(e) {
    e.event.stopPropagation();
    this.setState({ ...this.initialState });
    this.loadReport();
  }
  async printErrorsButtonClicked() {
    this.setState({
      loadIndicatorVisible: true
    });
    const data = await this.GetABErrorswData();
    this.setState({
      ABErros: data,
      isPrintPreviewPopupVisible: true,
      loadIndicatorVisible: false
    });
  }
  handleClosePreviewPopUpCallback() {
    this.setState({
      isPreviewGridPopupVisible: false,
    });
  };
  handleCloseWarningPopUpCallback = () => {
    this.setState({
      warningPopupVisible: false,
    });
  };
  handleCloseSuccessPopUpCallback = () => {
    this.setState({
      SuccessPopupVisible: false,
    });
  };
  handleClosePrintErrorsPopUpCallback() {
    this.setState({
      isPrintPreviewPopupVisible: false,
    });
  };
  selectionChanged(e) {
    let newItems = [...this.state.selectedItems];
    e.removedItems.forEach((item) => {
      const index = newItems.indexOf(item);
      if (index >= 0) {
        newItems.splice(index, 1);
      }
    });
    if (e.addedItems.length) {
      newItems = [...newItems, ...e.addedItems];
    }
    this.setState({
      selectedItems: newItems
    });
  }

  handleChange = (name, value) => {
    if (name === 'forceOrderDate' || name === 'forceInvDate' || name === 'forceShipDate') {
      this.setState((prevState) => ({
        updatePriceParams: {
          ...prevState.updatePriceParams,
          [name]: value ? 'Y' : 'N'
        }
      }));
    }
    else {
      this.setState((prevState) => ({
        updatePriceParams: {
          ...prevState.updatePriceParams,
          [name]: value
        }
      }));
    }

  };


  render() {
    return (
      <>
        <div>
          <div className="row">
            <div className="col-md-12 main-page">
              <div id="accordion" >
                <Accordion
                  dataSource={searchpanel}
                  collapsible={true}
                  multiple={false}
                  animationDuration={this.state.animationDuration}
                  selectedItems={this.state.selectedItems}
                  onSelectionChanged={this.selectionChanged}
                  itemTitleRender={() => (

                    <Toolbar className="accordian-toolbar">
                      <Item location="before">
                        <div className="title">
                          <h6
                            style={{
                              color: window._env_.Color2
                            }}
                          >
                            Update Price On OM Transactions
                          </h6>
                        </div>
                      </Item>

                      <Item location="after">
                        <Button className="accordianButton" text="Start" onClick={this.startButtonClicked} type="default" />
                      </Item>
                      <Item location="after">
                        <Button className="accordianButton" onClick={this.previewButtonClicked} text="Preview" />
                      </Item>
                      <Item location="after">
                        <Button className="accordianButton" onClick={this.resetButtonClicked} text="Reset" />
                      </Item>
                    </Toolbar>
                  )}
                  itemRender={(itemProps) => (
                    <div>
                      <div className="row">
                        <div className="col-md-3 ">
                          <SelectBox
                            dataSource={priceLevels}
                            value={this.state.updatePriceParams.priceLevel}
                            valueExpr='ID'
                            displayExpr='Text'
                            name="priceLevel"
                            stylingMode='outlined' labelMode="static"
                            label="Update Price Level On OM Transaction"
                            onValueChange={(e) => this.handleChange('priceLevel', e)}
                          />
                        </div>
                        <div className="col-md-3 ">
                          <SelectBox
                            dataSource={applyAdjustmentFactors}
                            value={this.state.updatePriceParams.applyAdjustmentFactor}
                            valueExpr='ID'
                            displayExpr='Text'
                            name="applyAdjustmentFactor"
                            stylingMode='outlined' labelMode="static"
                            label="Apply Item/Lot Adjustment Factor"
                            onValueChange={(e) => this.handleChange('applyAdjustmentFactor', e)}
                          />
                        </div>
                      </div>
                      <div className="row accordianLastRow">
                      <div className="col-md-12 ">
                        <p>This program allows you to update ITEM PRICING on existing OM Transactions. Totals will be recalculated based on the new price.</p>
                       </div>
                        </div>

                    </div>


                  )}
                  id="accordion-container" className="accordion-height"
                />
              </div>
            </div>
          </div>
          <div style={{ minWidth: "900px" }}>
            <Form
              id="form"
              labelMode="static"
              labelLocation="left"
              formData={this.state.formData}
              items={this.state.formItems}
              colCount={5}
            />
          </div>
        </div>
        <div className="row">
          <div className={this.state.opened ? 'toolbar-holder' : 'toolbar-holder collapse-drawer '}>
            <Toolbar >
              <Item location="before">
                <Button icon='menu' className="gridTopButton" onClick={() => this.setState({ opened: !this.state.opened })} />
              </Item>
            </Toolbar>
          </div>
        </div>
        <div className="row bg-white">
          <div>
            <LoadPanel
              shadingColor="rgba(0,0,0,0.4)"
              onHiding={(() => this.setState({ loadIndicatorVisible: false }))}
              visible={this.state.loadIndicatorVisible}
              showIndicator={true}
              shading={true}
              showPane={true}
              hideOnOutsideClick={false}
            />
            <Drawer
              opened={this.state.opened}
              openedStateMode={'shrink'}
              position={'left'}
              revealMode={'slide'}
              render={() =>
                <List
                  ref={list}
                  dataSource={this.state.report.whereInfoList}
                  pageLoadMode="scrollBottom"
                  style={{ backgroundColor: '#F6F7FB' }}
                  displayExpr="displayLabel"
                  searchEnabled={true}
                  searchExpr="displayLabel"
                  showSelectionControls={true}
                  selectionMode="multiple"
                  onSelectionChanged={this.dataFieldSelectionChanged}
                //onItemRendered={this.dataFieldRender}
                ></List>
              }
              closeOnOutsideClick={false}
              className={this.state.selectedItems.length>0? "ReportFilterPanelHeightAccordionOpen" : "GridHeightTabPanel-with-toolbar"}>

              <div>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                  id="gridContainer"
                  ref={dataGrid}
                  showBorders={true}
                  className={this.state.selectedItems.length>0?(this.state.formItems.length>0?"WMReportGridHeightWithAccordianDouble":"WMRTGridStyle"):"WMReportGridStyle-AccordianClosed"}
                  rowAlternationEnabled={true}
                  allowColumnReordering={true}
                  allowColumnResizing={true}
                  columnAutoWidth={true}
                  onEditorPreparing={this.editorPreparing}
                  onCellClick={this.CellClik}
                >
                  <Editing
                    mode="cell"
                    newRowPosition="last"
                    refreshMode="repaint"
                    allowUpdating={true}
                    useIcons={true}
                  />
                  <Column
                    dataField="displayLabel"
                    caption="Display Label"
                    allowEditing={false}
                  />
                  <Column dataField="orderBy" caption="Order By">
                    <Lookup
                      dataSource={orderByDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="prefix" caption="Prefix">
                    <Lookup
                      dataSource={prefixDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="group" caption="Group">
                    <Lookup
                      dataSource={groupDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="operation" caption="Operation">
                    <Lookup
                      dataSource={operationDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="from" caption="From" />
                  <Column dataField="to" caption="To" />
                  <Column caption="" allowEditing={false} cellRender={this.searchPopupCellRender} />
                </DataGrid>
              </div>
            </Drawer>
          </div>
        </div>
        {this.state.isPreviewGridPopupVisible &&
          <Popup
            visible={this.state.isPreviewGridPopupVisible}
            onHiding={this.handleClosePreviewPopUpCallback}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title={"Preview"}
            container=".dx-viewport"
            closeOnOutsideClick={true}
          >
            <UpdatePriceGridPreview dataSource={this.state.previewData} />
          </Popup>
        }
        {this.state.isPrintPreviewPopupVisible &&
          <Popup
            visible={this.state.isPrintPreviewPopupVisible}
            onHiding={this.handleClosePrintErrorsPopUpCallback}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title={"Print Errors"}
            container=".dx-viewport"
            closeOnOutsideClick={true}
          >
            <TransactionsPrintErrors dataSource={this.state.ABErros} reportname="ABR003" reportformat="Standard Abecas" />
          </Popup>
        }
        {this.state.warningPopupVisible &&
          <WarningMessagePopup
            visible={this.state.warningPopupVisible}
            onClose={this.handleCloseWarningPopUpCallback}
            message={this.state.warningMessage}
          />
        }
        {this.state.SuccessPopupVisible &&
          <Popup
            visible={this.state.SuccessPopupVisible}
            onHiding={this.handleCloseSuccessPopUpCallback}
            dragEnabled={true}
            closeOnOutsideClick={true}
            showCloseButton={true}
            title="Message"
            width={350}
            height="auto"
          >
            <div>
              <div className="mb-2">
                <div style={{ whiteSpace: "pre-line" }}>
                  {this.state.SuccessMessage}
                </div>
              </div>
              <div className="mb-2">
                <Button onClick={this.handleCloseSuccessPopUpCallback} type='default' text='Ok' />
              </div>
            </div>
          </Popup>

        }
      </>
    );
  }
  loadReport() {
    var that = this;
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.reports.GetReport}?reportName=${'OMUPDATEPRICE'}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {

        for (
          var i = 0;
          res.data.filterWhereInfoList != null &&
          i < res.data.filterWhereInfoList.length;
          i++
        ) {
          switch (res.data.filterWhereInfoList[i].fieldType) {
            case 5: // Flag
              for (
                var j = 0;
                res.data.filterWhereInfoList[i].items != null && j < res.data.filterWhereInfoList[i].items.length;
                j++
              ) {

                if (res.data.filterWhereInfoList[i].from == res.data.filterWhereInfoList[i].items[j].value) {
                  res.data.filterWhereInfoList[i].from = res.data.filterWhereInfoList[i].items[j].text;
                }

                if (res.data.filterWhereInfoList[i].to == res.data.filterWhereInfoList[i].items[j].value) {
                  res.data.filterWhereInfoList[i].to = res.data.filterWhereInfoList[i].items[j].text;
                }
              }
              break;
            default:
          }
        }

        for (
          var i = 0;
          res.data.whereInfoList != null &&
          i < res.data.whereInfoList.length;
          i++
        ) {
          switch (res.data.whereInfoList[i].fieldType) {
            case 5: // Flag
              for (
                var j = 0;
                res.data.whereInfoList[i].items != null && j < res.data.whereInfoList[i].items.length;
                j++
              ) {

                if (res.data.whereInfoList[i].from == res.data.whereInfoList[i].items[j].value) {
                  res.data.whereInfoList[i].from = res.data.whereInfoList[i].items[j].text;
                }

                if (res.data.whereInfoList[i].to == res.data.whereInfoList[i].items[j].value) {
                  res.data.whereInfoList[i].to = res.data.whereInfoList[i].items[j].text;
                }
              }
              break;
            default:
          }
        }

        that.setState({
          report: res.data,
        });

        var formData = new Object();

        var formItems = [];

        for (
          var i = 0;
          that.state.report.parameterList != null &&
          i < that.state.report.parameterList.length;
          i++
        ) {
          formData[that.state.report.parameterList[i].name] =
            that.state.report.parameterList[i].value;
          var formItem = new Object();
          formItem.dataField = that.state.report.parameterList[i].name;
          formItem.label = new Object();
          formItem.label.text = that.state.report.parameterList[i].label;
          switch (that.state.report.parameterList[i].parameterType) {
            case 1: // Integer
            case 2: // Decimal
              formItem.editorType = "dxNumberBox";
              break;
            case 3: // Boolean
              formItem.editorType = "dxCheckBox";
              break;
            case 4: // DateTime
              formItem.editorType = "dxDateBox";
              break;
            case 5: // Flag
              formItem.editorType = "dxSelectBox";
              formItem.editorOptions = new Object();
              formItem.editorOptions.items = [];

              for (
                var j = 0;
                j < that.state.report.parameterList[i].items.length;
                j++
              ) {
                var selectBoxItem = new Object();
                selectBoxItem.Value =
                  that.state.report.parameterList[i].items[j].value;
                selectBoxItem.Text =
                  that.state.report.parameterList[i].items[j].text;
                formItem.editorOptions.items.push(selectBoxItem);
              }

              formItem.editorOptions.displayExpr = "Text";
              formItem.editorOptions.valueExpr = "Value";
              break;
            default:
              formItem.editorType = "dxTextBox";
          }

          formItems.push(formItem);
        }

        that.setState({
          formData: formData,
        });

        that.setState({
          formItems: formItems,
        });

        var dataFilterDataSource = new ArrayStore({
          data: that.state.report.filterWhereInfoList,
          key: "displayLabel",
        });
        dataGrid.current.instance().option("dataSource", dataFilterDataSource);

        ignoreListSelectionChange = true;
        for (var i = 0; res.data.whereInfoList != null && i < res.data.whereInfoList.length; i++) {
          for (var j = 0; res.data.filterWhereInfoList != null && j < res.data.filterWhereInfoList.length; j++) {
            if (res.data.whereInfoList[i].origin == res.data.filterWhereInfoList[j].origin) {
              if (!list.current.instance().isItemSelected(i)) {
                list.current.instance().selectItem(i);
              }
              break;
            }
          }
        }
        ignoreListSelectionChange = false;

      })
      .catch((err) => {
        console.log(err, "Error getting report data");
      });
  }

  dataFieldSelectionChanged(e) {
    if (!ignoreListSelectionChange) {
      if (e.addedItems != null && e.addedItems.length === 1) {
        var dataSource = dataGrid.current.instance().getDataSource();
        dataSource
          .store()
          .insert(e.addedItems[0])
          .done(function (dataObj, key) {
            dataSource.reload();
          })
          .fail(function (error) {
            alert(error);
          });
      }

      if (e.removedItems != null && e.removedItems.length === 1) {
        var dataSource = dataGrid.current.instance().getDataSource();
        dataSource
          .store()
          .remove(e.removedItems[0].displayLabel)
          .done(function (dataObj, key) {
            dataSource.reload();
          })
          .fail(function (error) {
            alert(error);
          });
      }
    }
  }

  dataFieldRender(e) {
    var dataSource = dataGrid.current.instance().getDataSource();
    if (dataSource != null && dataSource._items != null) {
      var found = dataSource._items.find(i => i.origin == e.itemData.origin);
      if (found != null && found != undefined) {
        if (!e.component.isItemSelected(e.itemIndex)) {
          ignoreListSelectionChange = true;
          e.component.selectItem(e.itemIndex);
          ignoreListSelectionChange = false;
        }
      }
    }
  }

  editorPreparing(e) {
    if (e.parentType === "dataRow" && e.hasOwnProperty('row') && e.hasOwnProperty('dataField') && e.hasOwnProperty('editorName') &&
      (e.dataField === "from" || e.dataField === "to") && e.editorName == "dxTextBox") {
      if (e.row.data.lookupName == null || e.row.data.lookupName == "") {
        switch (e.row.data.fieldType) {
          case 1: // Integer
          case 2: // Decimal
            e.editorName = "dxNumberBox";
            break;
          case 3: // Boolean
            e.editorName = "dxCheckBox";
            break;
          case 4: // DateTime
            e.editorName = "dxDateBox";
            // const defaultValueChangeHandler = e.editorOptions.onValueChanged;
            var that = this;
            e.editorOptions.onValueChanged = function (args) {  // Override the default handler
              if (that.isValidDate(args.value)) {
                let dt = new Date(args.value);
                e.setValue((dt.getMonth() + 1) + '/' + dt.getDate() + '/' + dt.getFullYear());
                // e.setValue(((dt.getMonth() > 8) ? (dt.getMonth() + 1) : ('0' + (dt.getMonth() + 1))) + '/' + ((dt.getDate() > 9) ? dt.getDate() : ('0' + dt.getDate())) + '/' + dt.getFullYear());
              }
              else {
                e.setValue(args.value);
              }

              // If you want to modify the editor value, call the setValue function:
              // e.setValue(newValue);
              // Otherwise, call the default handler:
              //  defaultValueChangeHandler(args);
            }
            break;
          case 5: // Flag
            e.editorName = "dxSelectBox";
            e.editorOptions.items = [];

            for (var i = 0; i < e.row.data.items.length; i++) {
              var selectBoxItem = new Object();
              selectBoxItem.Value = e.row.data.items[i].text;
              selectBoxItem.Text = e.row.data.items[i].text;
              e.editorOptions.items.push(selectBoxItem);
            }

            e.editorOptions.displayExpr = "Text";
            e.editorOptions.valueExpr = "Text";
            e.editorOptions.showClearButton = true;
            break;
        }
      }
      else {
        e.editorName = "dxSelectBox";
        var selectstore = createStore({
          loadUrl: `${window._env_.REACT_APP_APIS}/${routes.reports.GetLookupData}`,
          loadParams: { lookupName: e.row.data.lookupName },
          onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`
            };
          }

        });
        e.editorOptions.dataSource = selectstore;
        e.editorOptions.searchEnabled = true;
        e.editorOptions.showClearButton = true;
        e.editorOptions.acceptCustomValue = true;
        // e.editorOptions.defaultValue = e.row.data.from;
      }
    }

    if (e.dataField === 'operation' && e.parentType === 'dataRow') {
      const defaultValueChangeHandler = e.editorOptions.onValueChanged;
      e.editorOptions.onValueChanged = function (args) { // Override the default handler
        defaultValueChangeHandler(args);
        if (args.value != 9) {
          e.component.cellValue(e.row.rowIndex, "to", "");
        }

      }
    }

    if (e.dataField === "to" && e.parentType === "dataRow") {
      e.editorOptions.disabled = e.row.data && e.row.data.operation !== 9;
    }
  }
  CellClik(e) {
    if (e.column && (e.column.caption.toLowerCase() == 'to' || e.column.caption.toLowerCase() == 'from')) {
      this.setState({
        colName: e.column.caption.toLowerCase(),
      });
    }
  };
  isValidDate(date) {
    return date && !isNaN(Date.parse(date));
  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(UpdatePrice);